export default "__VITE_PUBLIC_ASSET__7a4b3ccd__"